import { Link } from "react-router-dom";
import CavilowLogo from "../components/CavilowLogo";

export default function LegalShell({ title, eyebrow, children }) {
  return (
    <div className="min-h-screen text-white">
      <header className="max-w-4xl mx-auto px-6 lg:px-10 py-6 flex items-center justify-between border-b border-white/5">
        <Link to="/" className="flex items-center">
          <CavilowLogo size={36} textClass="text-2xl text-white" />
        </Link>
        <Link
          to="/"
          className="text-sm font-semibold text-slate-400 hover:text-white px-3 py-1.5 rounded-xl hover:bg-white/5 transition-colors"
        >
          ← Back to Cavilow
        </Link>
      </header>

      <main className="max-w-3xl mx-auto px-6 lg:px-10 py-12 lg:py-16 fade-up">
        {eyebrow && (
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#80FFEA] mb-3">{eyebrow}</p>
        )}
        <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tighter text-white">{title}</h1>
        <div className="mt-3 text-sm text-slate-400">Last updated: June 2026</div>
        <div className="mt-10 space-y-6 text-slate-300 leading-relaxed">{children}</div>
      </main>

      <footer className="border-t border-white/5 py-8 text-center text-xs text-slate-500 mt-12">
        <p>© {new Date().getFullYear()} Reivora. All rights reserved. Cavilow is a Reivora product.</p>
        <div className="mt-2 flex items-center justify-center gap-4">
          <Link to="/privacy" className="hover:text-[#80FFEA]">Privacy Policy</Link>
          <Link to="/terms" className="hover:text-[#80FFEA]">Terms of Use</Link>
          <Link to="/contact" className="hover:text-[#80FFEA]">Contact &amp; Support</Link>
        </div>
      </footer>
    </div>
  );
}

export function LegalSection({ title, children }) {
  return (
    <section>
      <h2 className="font-display font-bold text-xl text-white mb-2">{title}</h2>
      <div className="text-sm leading-relaxed text-slate-300 space-y-2">{children}</div>
    </section>
  );
}
